import styled from 'styled-components';
import theme from '../../../theme';

const Container = styled.div`
    display: flex;
    flex-direction: column;
    padding: 20px 30px;

    span {
        font-size: 12px;
        font-weight: 400;
        color: ${theme.textDark};
    }

    form {
        width: 100%;

        div + div {
            margin-top: 20px;
        }
    }

    button {
        margin: 20px 0 0 auto;
    }
`;
export { Container };